import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    messageList: {
      flex: 1,
      paddingHorizontal: theme.spacing.md,
    },
    messageListContent: {
      paddingVertical: theme.spacing.md,
    },
    userBubble: {
      alignSelf: 'flex-end',
      backgroundColor: theme.colors.primary,
      borderRadius: 16,
      borderBottomRightRadius: 4,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      marginVertical: theme.spacing.xxs,
      maxWidth: '80%',
    },
    userBubbleText: {
      color: theme.colors.white,
      fontSize: theme.fontSize.medium,
    },
    aiBubble: {
      alignSelf: 'flex-start',
      backgroundColor: theme.colors.grey10,
      borderRadius: 16,
      borderBottomLeftRadius: 4,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      marginVertical: theme.spacing.xxs,
      maxWidth: '80%',
    },
    aiBubbleText: {
      color: theme.colors.text,
      fontSize: theme.fontSize.medium,
    },
    typingContainer: {
      alignSelf: 'flex-start',
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      marginVertical: theme.spacing.xxs,
    },
    typingText: {
      marginLeft: theme.spacing.sm,
      color: theme.colors.grey50,
      fontSize: theme.fontSize.small,
    },
    confirmCard: {
      alignSelf: 'flex-start',
      backgroundColor: theme.colors.white,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.colors.primary,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.md,
      marginVertical: theme.spacing.xs,
      maxWidth: '85%',
    },
    confirmDescription: {
      color: theme.colors.text,
      fontSize: theme.fontSize.medium,
      marginBottom: theme.spacing.sm,
    },
    confirmButtons: {
      flexDirection: 'row',
      gap: theme.spacing.sm,
    },
    confirmButton: {
      flex: 1,
      paddingVertical: theme.spacing.sm,
      borderRadius: 8,
      alignItems: 'center',
      backgroundColor: theme.colors.primary,
    },
    confirmButtonText: {
      color: theme.colors.white,
      fontWeight: '600',
      fontSize: theme.fontSize.medium,
    },
    cancelButton: {
      flex: 1,
      paddingVertical: theme.spacing.sm,
      borderRadius: 8,
      alignItems: 'center',
      backgroundColor: theme.colors.error,
    },
    cancelButtonText: {
      color: theme.colors.white,
      fontWeight: '600',
      fontSize: theme.fontSize.medium,
    },
    inputBar: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.md,
      backgroundColor: theme.colors.white,
    },
    textInput: {
      flex: 1,
      borderColor: theme.colors.grey30,
      borderWidth: 1,
      borderRadius: 20,
      paddingVertical: (40 - theme.fontSize.medium) / 3,
      paddingHorizontal: theme.spacing.md,
      maxHeight: 150,
      fontSize: theme.fontSize.medium,
      color: theme.colors.text,
    },
    sendButton: {
      marginLeft: theme.spacing.sm,
      width: 40,
      height: 40,
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
    welcomeContainer: {
      alignSelf: 'center',
      alignItems: 'center',
      paddingVertical: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
    },
    welcomeText: {
      color: theme.colors.grey50,
      fontSize: theme.fontSize.medium,
      textAlign: 'center',
      marginTop: theme.spacing.sm,
    },
    suggestionsTitle: {
      color: theme.colors.grey50,
      textAlign: 'center',
      marginTop: theme.spacing.lg,
      marginBottom: theme.spacing.sm,
    },
    suggestionsWrap: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: theme.spacing.sm,
      maxWidth: 620,
    },
    suggestionChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.xs,
      borderWidth: 1,
      borderColor: theme.colors.primary + '40',
      backgroundColor: theme.colors.primary + '0A',
      borderRadius: theme.border.jumbo,
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
    },
    suggestionChipText: {
      color: theme.colors.primary,
    },
  })
